import { MyLoanInfo } from "pages/application/applicationService";

const isUsablePropertyValue = (value?: string): boolean => {
  const normalized = value?.trim().toLowerCase();
  return Boolean(normalized && normalized !== "tbd");
};

export const getLoanSidebarLabel = (loan: MyLoanInfo): string => {
  const street = loan.propertyInfo?.street?.trim();
  const city = loan.propertyInfo?.city?.trim();
  const state = loan.propertyInfo?.state?.trim();

  if (isUsablePropertyValue(street)) {
    return [street, city, state].filter(Boolean).join(", ");
  }

  const cityStateLabel = [city, state].filter(isUsablePropertyValue).join(", ");
  if (cityStateLabel) {
    return cityStateLabel;
  }

  return loan.loanPurpose?.trim() || "Loan";
};
